import { render, staticRenderFns } from "./PseudoTimeStudyConnection.vue?vue&type=template&id=6dda8e60&scoped=true"
import script from "./PseudoTimeStudyConnection.vue?vue&type=script&lang=js"
export * from "./PseudoTimeStudyConnection.vue?vue&type=script&lang=js"
import style0 from "./PseudoTimeStudyConnection.vue?vue&type=style&index=0&id=6dda8e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dda8e60",
  null
  
)

export default component.exports